"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var HighlightsSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M9,2 C12.8659932,2 16,5.13400675 16,9 C16,12.8659932 12.8659932,16 9,16 C5.13400675,16 2,12.8659932 2,9 C2,5.13400675 5.13400675,2 9,2 Z M9,3 C5.6862915,3 3,5.6862915 3,9 C3,12.3137085 5.6862915,15 9,15 C10.225696,15 11.3655513,14.6324723 12.3153738,14.0016091 L9,14 L9,13 L13.4716261,13.0006557 C13.9882614,12.4235945 14.394835,11.7459376 14.6583461,11.0006859 L9,11 L9,10 L14.9169061,10.0008069 C14.9715542,9.67534412 15,9.34099399 15,9 C15,8.65914411 14.9715772,8.3249267 14.9169725,7.99958857 L9,8 L9,7 L14.6586844,7.00027121 C14.3953028,6.2549814 13.9888522,5.5772688 13.4723307,5.0001315 L9,5 L9,4 L12.3175358,3.99982758 C11.3672813,3.36808573 10.2266262,3 9,3 Z" })));
};
HighlightsSmall.displayName = 'HighlightsSmall';
exports.default = HighlightsSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=HighlightsSmall.js.map